module.exports = __webpack_public_path__ + "resources/img/img_blue_prism1_m.2831f5e257573aeb393a3a8807099d51.png";